import React from "react";
import styles from "../../pages/styles";
import { activision, disney, hasbro, lego, riotgames } from "../../assets/images";

const InstructorExperience = () => {
  return (
    <div className="bg-darkprimary flex flex-col items-center justify-center w-full py-8 md:py-10 px-4 md:px-20">
      <div className="text-center max-w-4xl mb-6 md:mb-8">
        <h2 className={`${styles.biggerheadingwhite} mb-3 md:mb-4`}>
          Taught by <span className="relative inline-block">
            Industry Experts
            <span className="absolute shadow-sm bottom-0 left-1 w-full h-2 bg-pinkprimary/70 -z-10 -skew-x-[30deg] rounded-sm"></span>
          </span>
        </h2>
        <p className={`${styles.paragraphwhite}`}>
          Your child learns from professionals who've created content for the world's top gaming and entertainment companies.
        </p>
      </div>

      <div className="flex flex-wrap justify-evenly items-center gap-6 md:gap-8 w-full max-w-7xl">
        <LogoCard img={disney} alt="Disney" className="w-24 md:w-32" />
        <LogoCard img={activision} alt="Activision" className="w-28 md:w-36" />
        <LogoCard img={riotgames} alt="Riot Games" className="w-24 md:w-32" />
        <LogoCard img={hasbro} alt="Hasbro" className="w-20 md:w-28" />
        <LogoCard img={lego} alt="Lego" className="w-16 md:w-24" />
      </div>
    </div>
  );
};

const LogoCard = ({ img, alt, className }) => {
  return (
    <div className="flex items-center justify-center">
      <img src={img} alt={alt} className={`${className} filter brightness-0 invert opacity-90`} />
    </div>
  );
};

export default InstructorExperience;
